export enum SubmissionFunnelTypeEnum {
  DIRECT = 'direct',
  MORTGAGE_CLUB = 'mortgageClub',
  NETWORK = 'network',
}
